export default __webpack_public_path__ + "static/media/ic-clics-green.53824c0e.svg";